"use strict";
// (C) 2021 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditableLabel = void 0;
var tslib_1 = require("tslib");
tslib_1.__exportStar(require("./typings"), exports);
var EditableLabel_1 = require("./EditableLabel");
Object.defineProperty(exports, "EditableLabel", { enumerable: true, get: function () { return EditableLabel_1.EditableLabel; } });
//# sourceMappingURL=index.js.map